<template>
  <div class="liu" v-wechat-title="'人脸识别'">
    <!-- 活体 -->
    <div class="flex-s padding-t-10 padding-b-10 page-padding-l-r margin-t-10 color-f-bg">
      <div style="width: 105px">人脸识别</div>
      <div class="faceStyle" @click="onCameraImgClick('renLian')">
        <img v-if="renLian.webUrl" class="img" :src="renLian.webUrl" />
        <svg-icon v-else class-name="img" icon-class="camera_face" />
      </div>
    </div>
    <!-- 提示1 -->
    <div v-if="!renLian.webUrl" class="padding-t-10 padding-b-10 page-padding-l-r title-6 say-color">
      {{ renLian.photoTips }}
    </div>
    <!-- 提示2 -->
    <div v-else class="padding-t-10 padding-b-10 page-padding-l-r title-6 say-color">
      如遇活体检测失败，可以选择
      <span class="theme-color" @click="resetCameraInfo('renLian')">重新识别</span>或
      <span class="theme-color" @click="jumpManualAudit">申请人工审核</span>
    </div>
    <!-- 按钮 -->
    <div class="padding-t-10 padding-b-10 page-padding-l-r">
      <mt-button type="primary" size="large" :disabled="!renLian.webUrl" @click="onSubmitClick">提交</mt-button>
    </div>
    <!-- 人脸识别弹窗 -->
    <mt-popup class="liveness-popup" v-model="livingFacePopupVisible" :closeOnClickModal="false">
      <liveness ref="liveness"></liveness>
    </mt-popup>
  </div>
</template>

<script>
import Liveness from '@/components/Liveness';
import { GetIdNameFaceServiceUrl, UpdateIdCardInfoFaceActive, YMTivingThing } from '@/api/weChat.js';
import { CusToast, CusAlert, CusLoadingOpen, CusLoadingClose } from '@/utils/CustomToast';
import { SucceedHandle2, NotSucceedHandle } from '@/api/handle';
import { formatDateId } from '@/utils/utils.js';
import { mapMutations } from 'vuex';

export default {
  name: "LiveFace",
  components: { Liveness },
  data() {
    return {
      // 人脸照片
      renLian: {
        type: '',
        base64: '',
        fileUrl: '',
        webUrl: '',
        popupVisible: false,
        photoTips: PUBLIC_FACE_PHOTO_TIPS,
      },
      // 云码通人脸识别
      ymt: {
        type: '',
        base64: '',
        fileUrl: '',
        webUrl: '',
      },
      // 签名图片
      signatureImg: "",
      // 活体认证类型
      faceDetectActivity: 0,
      // 是否需要手持
      userIsNeedHandIdentityCard: false,
      // 身份证识别批次号 2023.4.23
      idCardBatchNo: '',
      // 身份证姓名
      idCardName: '',
      // 百度人脸弹窗开关
      livingFacePopupVisible: false,
    }
  },
  watch: {
    livingFaceImgUrl(val) {
      this.renLian.base64 = val;
      this.renLian.fileUrl = val;
      this.renLian.webUrl = val;
    },
    livingFacePopupStatus(val) {
      this.livingFacePopupVisible = val;
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.faceDetectActivity = parseInt(this.$route.query.facedetectactivity);
      this.userIsNeedHandIdentityCard = this.$route.query.needhandidcard === 'true';
      this.idCardBatchNo = this.$route.query.idcardbatchno;
      this.idCardName = this.$route.query.idcardname;
      this.signatureImg = this.$route.query.signatureimg ? decodeURIComponent(this.$route.query.signatureimg).replace('|', '?') : "";
      const imgType = this.$route.query.imgtype;
      if (imgType) {
        this.renLian.webUrl = decodeURIComponent(this.$route.query.rlweburl).replace('|', '?');
        switch (imgType) {
          case "ymt":
            this.yMTivingThing();
            break;
          case "renLian":
            break;
        }
      }
    });
  },
  methods: {
    ...mapMutations(['setLivingFacePopupStatus']),
    // 人脸识别不同方式不同处理
    jumpToLiveness() {
      let data = null;
      switch (this.faceDetectActivity) {
        case 0: // 不做人脸识别，直接拍照片
          data = this.createPostMessage('renLian');
          wx.miniProgram.postMessage({ data });
          wx.miniProgram.redirectTo({
            url: '/pages/media/media',
          });
          break;
        case 1: // 小视
          CusAlert('尚未开通甄视科技的人脸识别服务，请更换其他服务');
          break;
        case 2: // 百度
          this.setLivingFacePopupStatus(true);
          this.$refs.liveness.drawBaiduSessionCode();
          break;
        case 3: // 云码通
          data = this.createPostMessage('ymt');
          wx.miniProgram.postMessage({ data });
          wx.miniProgram.redirectTo({
            url: '/pages/media/media',
          });
          break;
      }
    },
    // 调用接口上传人脸照片
    updateIdCardInfoFaceActive(url, callback = null) {
      const batchNumber = Math.floor(Math.random() * 900000000 + 100000000);
      UpdateIdCardInfoFaceActive({ url, batchNumber })
        .then(res => {
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              callback && callback();
            },
            () => {
              callback && callback();
            }
          );
        })
        .catch(err => {
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 重新拍照
    resetCameraInfo(name) {
      this[name].base64 = '';
      this[name].fileUrl = '';
      this[name].webUrl = '';
      if (name === 'renLian') {
        this[name].photoTips = PUBLIC_FACE_PHOTO_TIPS
      }
    },
    // 跳人工审核
    jumpManualAudit() {
      if (!this.renLian.webUrl) {
        CusToast('请先进行人脸识别');
        return;
      }
      this.updateIdCardInfoFaceActive(this.renLian.webUrl, () => {
        CusAlert('已为您申请人工审核，预计将在1个工作日内完成。请继续完成后续认证流程，否则将无法通过人工审核', () => {
          this.replacePage('auth/manualreview', { idcardname: this.idCardName });
        });
      });
    },
    // 调用云码通的接口做人脸识别
    yMTivingThing() {
      CusLoadingOpen();
      YMTivingThing({ url: this.renLian.webUrl })
        .then(res => {
          CusLoadingClose();
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              this.renLian.webUrl = this.renLian.webUrl;
              this.renLian.fileUrl = this.renLian.webUrl;
              this.renLian.base64 = this.renLian.webUrl;
              res.msg && CusAlert(res.msg);
            },
            (code, msg) => {
              msg && CusAlert(msg, () => {
                this.renLian.webUrl = "";
                this.renLian.fileUrl = "";
                this.renLian.base64 = "";
                this.btnStatus = 3;
              });
            }
          );
        })
        .catch(err => {
          CusLoadingClose();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 创建向小程序传递消息的参数对象
    createPostMessage(imgTypeStr) {
      return {
        page: 'media',
        h5Page: 'LiveFace',
        imgType: imgTypeStr,
        signatureImg: encodeURIComponent(this.signatureImg.replace('?', '|')),
        idCardBatchNo: this.idCardBatchNo,
        idCardName: this.idCardName,
      };
    },
    // 提交数据
    onSubmitClick() {
      const data = {
        url: this.renLian.webUrl,
        batchNo: this.idCardBatchNo,
        handSignUrl: this.signatureImg
      };
      CusLoadingOpen();
      GetIdNameFaceServiceUrl(data)
        .then(res => {
          CusLoadingClose();
          if (res.code === 0) {
            this.updateIdCardInfoFaceActive(this.renLian.webUrl, () => {
              if (this.needHandIdCard) {
                //  手持
                this.replacePage('auth/handidcard', {
                  idCardName: this.idCardName,
                  idCardNum: this.idCardNum,
                });
              } else {
                // 不需要手持，则跳转回小程序的结算卡添加页面
                // 1.向小程序发消息，更新状态
                wx.miniProgram.postMessage({ data: { page: "refresh" } });
                // 2.跳转小程序添加储蓄卡的页面
                wx.miniProgram.redirectTo({
                  url: `/pages/bankCard/savingsCard/savingsCard?idCardName=${this.idCardName}&flowName=认证流程`,
                });
              }
            });
          } else {
            this.updateIdCardInfoFaceActive(this.renLian.webUrl, () => {
              this.btnStatus = 3;
              CusAlert(res.msg, () => {
                if (res.innerCode === 7776) {
                  this.replacePage('auth/manualreview', { idcardname: this.idCardName });
                }
              });
            });
          }
        })
        .catch(err => {
          CusLoadingClose();
          CusAlert(err.msg);
        });
    },
    // 拍照组件点击事件
    onCameraImgClick(type) {
      switch (type) {
        case "renLian":
          this.jumpToLiveness();
          break;
      }
    },
  }
}
</script>